import clsx from 'clsx';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../../../../Translations';

export interface Props {
  submit: () => void;
}

function NoParticipants({ submit }: Props) {
  return (
    <>
      <div className="max-h-60 h-60 text-sm overflow-y-auto">
        <div className="text-sm">
          <T kind="Start adding participants by searching them in the field above." />
        </div>
      </div>
      <div
        className={clsx(
          'pointer-events-none rounded-md bg-gray-500 text-white px-3 py-2 text-sm w-24 text-center mt-4',
        )}
        onClick={submit}
      >
        <T kind="Next" />
      </div>
    </>
  );
}

export default observer(NoParticipants);
